import { useCallback } from 'react'
import CheckboxField from 'components/UI/CheckboxField/CheckboxField'
import './quickFilters.css'

const QUICK_FILTERS = [
  // ten element All Inclusive bedzie ukryty na screen width <= 370px
  {
    id: 'boarding_all_inclusive',
    label: 'All Inclusive',
    group: 'boarding',
    items: ['All Inclusive'],
  },
  // ten element All Inclusive bedzie ukryty na screen width > 370px
  {
    id: 'boarding_all_inclusive_shorten',
    label: 'All Incl.',
    group: 'boarding',
    items: ['All Inclusive'],
  },
  {
    id: 'rating_4+',
    label: 'Min. 4*',
    group: 'rating',
    items: ['4', '5'],
  },
  {
    id: 'daysrange_6_8',
    label: '6-8 dni',
    group: 'daysrange',
    items: ['6-8'],
  },
  {
    id: 'last_minute',
    label: 'Last Minute',
    group: 'lastminute',
    items: ['last minute'],
  },
]

const isQuickFilterChecked = (others, filter) => {
  const group = others.find((g) => g.textContent === filter.group)
  if (!group) return false
  return filter.items.every((itemName) => {
    const item = group.items.find((i) => i.textContent === itemName)
    return item?.selected
  })
}

const QuickFilters = ({ others, lastMinute, onClickFilterTypeOther, onClickLastMinute }) => {
  const toggle = useCallback(
    (filter) => {
      const isChecked = isQuickFilterChecked(others, filter)
      onClickFilterTypeOther(filter.items, !isChecked)
    },
    [others, onClickFilterTypeOther],
  )

  return (
    <div className="quick_filters">
      {QUICK_FILTERS.map((filter) => (
        <CheckboxField
          id={filter.id}
          key={filter.id}
          name={filter.id}
          contantSize
          checked={filter.id === 'last_minute' ? lastMinute : isQuickFilterChecked(others, filter)}
          onClick={() => filter.id === 'last_minute' ? onClickLastMinute(!lastMinute) : toggle(filter)}
        >
          <label>{filter.label}</label>
        </CheckboxField>
      ))}
    </div>
  )
}

export default QuickFilters
